<script>
	import Intro from '../src/components/Intro.svelte';
	import EmbedForm from '../src/components/EmbedForm.svelte';
</script>

<main>
	<Intro/>
	<EmbedForm/>
</main>
<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
  </style>